import { regexExp } from '@business/rules/regex';
import * as yup from 'yup';

export const relativeFormSchema = yup.object().shape({
  name: yup
    .string()
    .required('Name is required')
    .trim()
    .min(1, 'Name cannot be empty'),
  relationshipType: yup.string().when('$isNameSelected', ([isNameSelected]) => {
    return !Boolean(isNameSelected)
      ? yup.string().required('Relationship type is required')
      : yup.string().notRequired();
  }),
  gender: yup.string().when('$isNameSelected', ([isNameSelected]) => {
    return !Boolean(isNameSelected)
      ? yup.string().required('Gender is required')
      : yup.string().notRequired();
  }),
  nickName: yup.string().trim(),
  birthday: yup.string(),
  birthPlace: yup.string().trim(),
  dadName: yup.string().trim(),
  momName: yup.string().trim(),
  diary: yup.string().trim(),
  isPrivate: yup.boolean(),
  familyMemberName: yup.string(),
  familyMemberRelation: yup.string(),
  email: yup
    .string()
    .trim()
    .nullable()
    .notRequired()
    .test(
      'email-or-empty',
      'Email is not valid',
      value => !value || regexExp.emailRegex.test(value)
    )
});
